/** Keys shared across all apps (same browser origin / localforage instance). */
export const SHARED_STORAGE_KEYS = {
	DARK_MODE: "served:app:isDarkMode",
	DIGITAL_MENU_LANGUAGE: "served:app:digitalMenuLanguage",
} as const;
